import { helpers } from "../../../../../packages/helpers";
import type { MessagesByDate, Message } from "../../../types";

const { getId } = helpers.utilities;
const { getFormattedDate } = helpers.date;

type MessagesByDates = Array<MessagesByDate>;

export const getMessagesByDates = (messages: Array<Message>): MessagesByDates =>
  messages.reduce<MessagesByDates>((acc, message) => {
    const messageFullDate = message.date.split(",")[0];
    const messageShortDate = getFormattedDate(messageFullDate, "dd MMMM");
    const dateIndex = acc.findIndex(({ date }) => messageShortDate === date);

    if (dateIndex === -1) {
      const newMessagesDate = {
        id: getId("message"),
        date: messageShortDate,
        items: [message],
      };

      return [...acc, newMessagesDate];
    }

    return acc.map((messagesByDate, index) => {
      if (index === dateIndex) {
        const items = [...messagesByDate.items, message];

        return { ...messagesByDate, items };
      }

      return messagesByDate;
    });
  }, []);
